import { createSelector } from "reselect";
import getChapterButtonSize from "./getChapterButtonSize";
import getControlsPadding from "./getControlsPadding";

const getControlsHeight = createSelector(
  [getChapterButtonSize, getControlsPadding],
  (chapterButtonSize, controlsPadding) =>
    controlsPadding * 2 + chapterButtonSize,
);

export default getControlsHeight;
